import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import { motion } from "framer-motion";
import { toast } from "sonner";

const Footer = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.8,
        ease: "easeOut",
      },
    }),
  };
  const [data, setData] = useState([]);
  const [timeData, setTimeData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const handleSubscribe = async () => {
    if (!email) return toast.warning("Please enter your email address.");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email))
      return toast.error("Please enter a valid email address.");

    try {
      const response = await fetch(
        "https://admin.ezerautomotive.co.nz/api/subscribe/",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        },
      );

      if (!response.ok) throw new Error("Failed to subscribe");

      const data = await response.json();
      console.log("Subscription successful:", data);
      toast.success("Subscribed successfully!");

      setEmail("");
    } catch (error) {
      console.error("Subscription error:", error.message);
      toast.error("Subscription failed. Please try again later.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://admin.ezerautomotive.co.nz/api/settings/",
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        setData(result);
        console.log(result, "settings");
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchTimimg = async () => {
      try {
        const response = await fetch(
          "https://admin.ezerautomotive.co.nz/api/working-hours/",
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        setTimeData(result);
        console.log(result, "timimg result");
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTimimg();
  }, []);

  const handleScroll = (event, id) => {
    event.preventDefault();
    const currentPath = window.location.pathname;
    if (currentPath !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      const section = document.getElementById(id);
      if (section) {
        const yOffset = -210;
        const y =
          section.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  };

  const convertTo12HourFormat = (timeStr) => {
    const [hour, minute] = timeStr.split(":");
    const date = new Date();
    date.setHours(hour, minute);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <motion.div
          className="footer-section logo-section"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeInUp}
        >
          <div className="logo">
            <img
              src="/assets/logo/Ezer.png"
              alt="Logo"
              className="logo-image-footer"
            />
          </div>
          <div className="social-media-card">
            {/* Instagram */}
            <div className="socialContainer containerOne">
              <a
                href="https://www.instagram.com/ezer_automotive?igsh=YXoydjVidHEyNXdk"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 16 16" className="socialSvg instagramSvg">
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                </svg>
              </a>
            </div>

            {/* WhatsApp */}
            <div className="socialContainer containerFour">
              <a
                href="https://wa.me/64223067929"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 16 16" className="socialSvg whatsappSvg">
                  <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                </svg>
              </a>
            </div>

            {/* Facebook */}
            <div className="socialContainer containerFive">
              <a
                href="https://www.facebook.com/share/1GERsY8Vg4/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="socialSvg"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                </svg>
              </a>
            </div>

            {/* Threads */}
            <div className="socialContainer containerSix">
              <a
                href="https://www.threads.com/@ezer_automotive?invite=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="socialSvg"
                  viewBox="0 0 448 512"
                >
                  <path d="M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z" />
                </svg>
              </a>
            </div>

            {/* TikTok */}
            <div className="socialContainer containerSeven">
              <a
                href="https://www.tiktok.com/@ezer.automotive?_r=1&_t=ZS-97NUnHle5TT"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="socialSvg tiktokSvg"
                  viewBox="0 0 448 512"
                >
                  <path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" />
                </svg>
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="footer-section"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeInUp}
        >
          <h3 className="chakra-petch-semibold">CONTACT US</h3>
          <p
            style={{
              marginBottom: "25px",
              fontSize: "18px",
              lineHeight: "28px",
              cursor: "pointer",
            }}
            onClick={() =>
              window.open("https://maps.app.goo.gl/DusifRbetENoFq8Y6")
            }
          >
            <span>
              <i
                className="fa-solid fa-location-dot"
                style={{
                  paddingRight: "5px",
                  fontSize: "25px",
                  color: "#fd2906",
                }}
              ></i>
            </span>
            {data[0]?.address1}
          </p>
          <p style={{ marginBottom: "15px", fontSize: "18px" }}>
            {data[0]?.contact_number1}
          </p>
          <p style={{ marginBottom: "15px", fontSize: "18px" }}>
            {data[0]?.contact_number2}
          </p>
          <p style={{ marginBottom: "15px", fontSize: "18px" }}>
            {data[0]?.email}
          </p>
        </motion.div>

        <motion.div
          className="footer-section"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeInUp}
        >
          <h3 className="chakra-petch-semibold">MORE</h3>
          <ul className="columns">
            <div>
              <li onClick={() => navigate("/")}>HOME</li>
              <li onClick={() => navigate("/services")}>SERVICES</li>
              <li onClick={(event) => handleScroll(event, "contact")}>
                CONTACT US
              </li>
              <li onClick={(event) => handleScroll(event, "packages")}>
                PACKAGES
              </li>
            </div>
          </ul>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeInUp}
          className="footer-section"
        >
          <h4 className="chakra-petch-semibold">
            Forget the former things; do not dwell on the past.
            <br />
            <br />
            See, I am doing a new thing! Now it springs up; do you not perceive
            it? I am making a way in the wilderness and streams in the
            wasteland.
            <br />
            <br />
            Isaiah 43:18-19 NIV
          </h4>
          <div className="payment-card">
            <img src="/assets/cards/afterpay.jpg" alt="Afterpay" />
            <img src="/assets/cards/gem_pay.webp" alt="Gem Pay" />
            <img src="/assets/cards/QMC.svg" alt="QMC" />
            <img src="/assets/cards/visa.svg" alt="Visa" />
          </div>
        </motion.div>
      </div>

      <div className="footer-subscribe">
        <div className="footer-left">
          <div className="headline chakra-petch-semibold">
            <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
            <strong>Get the latest updates on new services and offers</strong>
          </div>
          <div className="subtext font-mulish">
            Be the first to know about offers, new products and discounted
            products
          </div>
        </div>
        <div className="footer-right">
          <input
            type="email"
            placeholder="Enter your email address"
            className="email-input font-mulish"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            className="subscribe-button font-mulish"
            onClick={handleSubscribe}
          >
            Subscribe
          </button>
        </div>
      </div>

      <motion.div
        className="footer-bottom"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        variants={fadeInUp}
      >
        <p>
          <span className="orange">adsvoc.com</span> © All rights reserved.
          Copyrights 2025
        </p>
      </motion.div>
    </footer>
  );
};

export default Footer;
